module.exports = __webpack_public_path__ + "img/KW_pad.9fa1c45a.png";